<dx-circular-gauge [value]="averageCareerValuation"
                   [rangeContainer]="rangeContainer"
                   (onInitialized)="onInitialized($event)">
    <dxo-circular-gauge-scale [startValue]="0"
                              [endValue]="100"
                              [tickInterval]="10">
        <dxo-circular-gauge-label [useRangeColors]="true"></dxo-circular-gauge-label>
    </dxo-circular-gauge-scale>
    <dxo-circular-gauge-tooltip [enabled]="true">
        <dxo-circular-gauge-format type="fixedPoint"
                                   [precision]="1"></dxo-circular-gauge-format>
    </dxo-circular-gauge-tooltip>
</dx-circular-gauge>
